import { CONTENT_TYPES } from 'services/contentful/constants'

export const ABOUT_ROUTE = '/about'
export const ACCELERATION_LOAN_ROUTE = '/acceleration-loan'
export const ACHIEVE_HOME = '/'
export const ADVERTORIAL_ROUTE = '/a/'
export const AR_DISCLAIMERS_ROUTE = '/debt-relief/disclaimers'
export const AR_HOW_ROUTE = '/debt-relief/how-achieve-debt-relief-works'
export const AR_WHO_ROUTE = '/debt-relief/who-achieve-debt-relief-helps'
export const AR_WHY_ROUTE = '/debt-relief/why-choose-achieve-debt-relief'
export const AUTHORS_ROUTE = '/authors'
export const AUTHOR_ROUTE = '/author'
export const AUTHORS_ROUTE_FDR = '/author'
export const BLOG_ROUTE = '/about/blog'
export const CAREERS_ROUTE = 'https://careers.achieve.com'
export const CONSUMER_NAME_ROUTE = '/dollars-sense'
export const CONTACT_US_ROUTE = '/about/contact-us'
export const DEBT_CONSOLIDATION = '/debt-consolidation'
export const DEBT_INCOME_RATIO_ROUTE = '/tools/debt-income-ratio-calculator'
export const DEBT_PAYOFF_CALCULATOR_ROUTE = '/tools/debt-payoff-calculator'
export const DIRECT_MAILER_ROUTE = '/savenow?brand=achieve&section=achieve_dm'
export const EMPLOYEE_STORIES_ROUTE = '/about/employee-stories'
export const GET_STARTED_ROUTE = '/get-started?brand=achieve&section=achieve_web'
export const GET_STARTED_PATH = '/get-started'
export const FDR_GET_STARTED_ROUTE = 'apply.freedomdebtrelief.com'
export const GET_STARTED_ROUTE_DR = '/get-started?brand=achieve&section=achieve_dr'
export const GET_STARTED_ROUTE_HL = '/get-started?brand=achieve&section=achieve_hl'
export const GOOD_ROUTE = '/good-app'
export const HOME_EQUITY_LOAN_MP_ROUTE = '/home-equity-loan-mp'
export const HOME_EQUITY_LOAN_ROUTE = '/home-equity-loan'
export const LANDER_ROUTE = '/l/'
export const LANDING_PAGE_ROUTE = '/lp/'
export const GLOSSARY_PAGE = '/glossary/'
export const LEARN_ROUTE = '/learn'
export const LEARN_ROUTE_FDR = '/l'
export const LICENSE_ROUTE = '/licenses'
export const MEMBER_STORIES_ROUTE = '/about/member-stories'
export const MOLO_ROUTE = '/molo-app'
export const MXP_DEBT_CHECKUP_ROUTE = '/debt-checkup'
export const MXP_INFO_ROUTE = '/mxp-info'
export const PARTNERS_ROUTE = '/about/partners'
export const PERSONAL_LOANS_ROUTE = '/personal-loans'
export const POLICIES_ROUTE = '/policies'
export const PRESS_ROUTE = '/about/press'
export const DEBT_RELIEF_APPLY_ROUTE = 'debt-relief/apply'
export const DEBT_RELIEF_ROUTE = '/debt-relief'
export const ROUTE_ASSET_EXCEPT = 'assets.ctfassets.net'
export const ROUTE_EXCEPT_NOFOLLOW = [
  'achieve.com',
  'freedomdebtrelief.com',
  'freedomfinancialnetwork.com',
  'bills.com',
  'weeklyfinancialsolutions.com',
  'dev.ffngcp.com',
  'stg.ffngcp.com',
  'prd.ffngcp.com',
]
export const SIGN_IN_ROUTE = '/signin'
export const WALL_OF_FAME_ROUTE = '/wall-of-fame/'
export const MOBILE_APP_DOWNLOAD_FDR_ROUTE = '/mobile-app-download'
export const HELOC_TOOL_ROUTE = '/tools/heloc-payment-calculator'

export const CONSULTATION_BILLS = 'https://consultation.bills.com/home'
export const ACHIEVE_GET_STARTED_URL = 'https://www.achieve.com/get-started'
export const ACHIEVE_GOOD_APP_URL = 'https://www.achieve.com/good-app'

/**
 * Returns the article page route key based on the content type
 */
export const ARTICLE_TYPE_TO_BASE_PATH = {
  [CONTENT_TYPES.ARTICLE_FULL]: LEARN_ROUTE,
  [CONTENT_TYPES.CONSUMER_BLOG_FULL]: CONSUMER_NAME_ROUTE,
  [CONTENT_TYPES.CORPORATE_BLOG_FULL]: BLOG_ROUTE,
}

/**
 * Returns the product key based on the provided route.
 *
 * @param {string} route - The route for which to get the product key.
 * @returns {string} The product key. Returns an empty string if the route does not match any product.
 */
export const getProductKeyByRoute = (route) => {
  if (route.startsWith(DEBT_RELIEF_ROUTE)) {
    return 'achieve_dr'
  } else if (route.startsWith(PERSONAL_LOANS_ROUTE)) {
    return 'achieve_pl'
  } else if (route.startsWith(HOME_EQUITY_LOAN_ROUTE)) {
    return 'achieve_hl'
  } else {
    return 'achieve_web'
  }
}

/**
 * Updates or adds a query string parameter in a given URI.
 *
 * @param {string} uri - The URI to be updated.
 * @param {string} key - The query string parameter key.
 * @param {string} value - The new value for the query string parameter.
 * @returns {string} The updated URI with the new query string parameter.
 */
export function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  const separator = uri.indexOf('?') !== -1 ? '&' : '?'
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2')
  } else {
    return uri + separator + key + '=' + value
  }
}
